/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2024-01-11 18:34:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-17 16:48:39
 * @FilePath: /app/modules/themePage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 专题页路由
import {
  AURORA_COLLECTION_PATH,
  BLUE_LIGHT_COLLECTION_PATH,
  CUSTOM_NEW_EYE_GLASSES_PATH,
  CUSTOM_THEME_PATH,
  ECO_COLLECTION_PATH,
  NEON_COLLECTION_PATH,
  NEW_EYE_GLASSES_PATH,
  PHOTOCHROMIC_LENSES_COLLECTION_PATH,
  PROGRESSIVE_LENSES_COLLECTION_PATH,
  TRANSITIONS_COLLECTION_PATH,
} from '@/assets/js/product';

export default [
  // 极光专题页
  {
    path: '/aurora-collection',
    name: 'AuroraCollection',
    component: () =>
      import('@/views/theme-page/aurora/AuroraCollection.vue').then((r) => r.default || r),
    meta: {
      keepalive: true,
      cnName: '极光专题页',
    },
  },
  {
    path: AURORA_COLLECTION_PATH, // /极光专题页 的魔方预览页面
    name: 'AuroraCollectionView',
    meta: {
      pos: 0,
      cnName: '极光专题页-魔方预览页',
    },
    component: () =>
      import('@/views/theme-page/aurora/AuroraCollection.vue').then((r) => r.default || r),
  },
  // 霓虹专题页
  {
    path: '/neon-collection',
    name: 'NeonCollection',
    meta: {
      cnName: '霓虹专题页',
    },
    component: () =>
      import('@/views/theme-page/neon/NeonCollection.vue').then((r) => r.default || r),
  },
  {
    path: NEON_COLLECTION_PATH, // 霓虹专题页 的魔方预览页面
    name: 'NeonCollectionView',
    meta: {
      cnName: '霓虹专题页-魔方预览页',
      pos: 0,
    },
    component: () =>
      import('@/views/theme-page/neon/NeonCollection.vue').then((r) => r.default || r),
  },
  // 防蓝光专题页
  {
    path: '/blue-light-glasses',
    name: 'BlueLightCollection',
    meta: {
      cnName: '防蓝光专题页',
    },
    component: () =>
      import('@/views/theme-page/blue-light/BlueLightCollection.vue').then((r) => r.default || r),
  },
  {
    path: BLUE_LIGHT_COLLECTION_PATH, // 防蓝光专题页 的魔方预览页面
    name: 'BlueLightCollectionView',
    meta: {
      pos: 0,
      cnName: '防蓝光专题页-魔方预览页',
    },
    component: () =>
      import('@/views/theme-page/blue-light/BlueLightCollection.vue').then((r) => r.default || r),
  },
  // 渐进镜专题页
  {
    path: '/progressive-lenses',
    name: 'ProgressiveCollection',
    meta: {
      cnName: '渐进镜专题页',
    },
    component: () =>
      import('@/views/theme-page/progressive/ProgressiveCollection.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: PROGRESSIVE_LENSES_COLLECTION_PATH, // 渐进镜片专题页 的魔方预览页面
    name: 'ProgressiveCollectionView',
    meta: {
      pos: 0,
      cnName: '渐进镜专题页-魔方预览页',
    },
    component: () =>
      import('@/views/theme-page/progressive/ProgressiveCollection.vue').then(
        (r) => r.default || r,
      ),
  },
  // 变色镜片专题页
  {
    path: '/photochromic-lenses',
    name: 'PhotochromicCollection',
    meta: {
      cnName: '变色镜片专题页',
    },
    component: () =>
      import('@/views/theme-page/photochromic/PhotochromicCollection.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: PHOTOCHROMIC_LENSES_COLLECTION_PATH, // 变色镜片专题页 的魔方预览页面
    name: 'PhotochromicCollectionView',
    meta: {
      pos: 0,
      cnName: '变色镜片专题页-魔方预览页',
    },
    component: () =>
      import('@/views/theme-page/photochromic/PhotochromicCollection.vue').then(
        (r) => r.default || r,
      ),
  },
  // 环保专题页
  {
    path: '/eco-glasses',
    name: 'EcoCollection',
    meta: {
      cnName: '环保专题页',
    },
    component: () => import('@/views/theme-page/eco/EcoCollection.vue').then((r) => r.default || r),
  },
  {
    path: ECO_COLLECTION_PATH, // 环保专题页 的魔方预览页面
    name: 'EcoCollectionView',
    meta: {
      pos: 0,
      cnName: '环保专题页-魔方预览页',
    },
    component: () => import('@/views/theme-page/eco/EcoCollection.vue').then((r) => r.default || r),
  },
  // 全视线专题页
  {
    path: '/transitions-lenses',
    name: 'TransitionsCollection',
    meta: {
      cnName: '全视线专题页',
    },
    component: () =>
      import('@/views/theme-page/transitions/TransitionsCollection.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: TRANSITIONS_COLLECTION_PATH, // 全视线专题页 的魔方预览页面
    name: 'TransitionsCollectionView',
    meta: {
      cnName: '全视线专题页-魔方预览页',
      pos: 0,
    },
    component: () =>
      import('@/views/theme-page/transitions/TransitionsCollection.vue').then(
        (r) => r.default || r,
      ),
  },
  // 自定义专题页
  {
    path: '/collections/:path',
    name: 'CustomTheme',
    meta: {
      cnName: '自定义专题页',
    },
    component: () =>
      import('@/views/theme-page/custom-theme/CustomTheme.vue').then((r) => r.default || r),
  },
  {
    path: `${CUSTOM_THEME_PATH}/:path`, // 自定义专题页 的魔方预览页面
    name: 'CustomThemeView',
    meta: {
      cnName: '自定义专题页-魔方预览页',
      pos: 0,
    },
    component: () =>
      import('@/views/theme-page/custom-theme/CustomTheme.vue').then((r) => r.default || r),
  },
  // 全量折扣页面 （自定义专题页特例：需要一个单独路由） (此页面的预览不做特殊处理)
  {
    path: '/special-offers',
    name: 'SpecialOffers',
    meta: {
      cnName: '全量折扣页',
    },
    component: () =>
      import('@/views/theme-page/special-offers/SpecialOffers.vue').then((r) => r.default || r),
  },
  // new-in专题页
  {
    path: '/collections/new-eyeglasses',
    name: 'newEyeGlasses',
    meta: {
      cnName: '新品专题页',
    },
    component: () =>
      import('@/views/theme-page/new-eyeglasses/newEyeGlasses.vue').then((r) => r.default || r),
  },
  {
    path: '/collections/fsa-hsa-glasses',
    name: 'FsaHsaGlasses',
    meta: {
      cnName: 'HSA FSA常青页',
    },
    component: () =>
      import('@/views/theme-page/fsa-hsa/FsaHsaGlasses.vue').then((r) => r.default || r),
  },
  {
    path: NEW_EYE_GLASSES_PATH, // 新品专题页 的魔方预览页面
    name: 'newEyeGlassesView',
    meta: {
      pos: 0,
      cnName: '新品专题页-魔方预览页',
    },
    component: () =>
      import('@/views/theme-page/new-eyeglasses/newEyeGlasses.vue').then((r) => r.default || r),
  },
  // 自定义new-in专题页
  {
    path: '/campaigns/:path',
    name: 'CustomNewEyeGlasses',
    meta: {
      cnName: '新品专题配置页',
    },
    component: () =>
      import('@/views/theme-page/custom-new-eyeglasses/CustomNewEyeGlasses.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: `${CUSTOM_NEW_EYE_GLASSES_PATH}/:path`, // 自定义新品专题页 的魔方预览页面
    name: 'CustomNewEyeGlassesView',
    meta: {
      pos: 0,
      cnName: '新品专题配置页-魔方预览页',
    },
    component: () =>
      import('@/views/theme-page/custom-new-eyeglasses/CustomNewEyeGlasses.vue').then(
        (r) => r.default || r,
      ),
  },
  // trendBook
  {
    path: '/cult-vision',
    name: 'TrendBookIndex',
    meta: {
      cnName: 'Trendbook主题页',
    },
    component: () =>
      import('@/views/theme-page/trendBookIndex/TrendBookIndex.vue').then((r) => r.default || r),
  },
  {
    path: '/cult-vision/style/:id',
    name: 'TrendBookReusedPage',
    meta: {
      cnName: 'TrendbookStyle页',
    },
    component: () =>
      import('@/views/theme-page/trendBookReusedPage/TrendBookReusedPage.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/essentials',
    name: 'TrendBookEssentials',
    meta: {
      cnName: 'Essentials页',
    },
    component: () =>
      import('@/views/theme-page/trendBookEssentials/TrendBookEssentials.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/bohemian',
    name: 'TrendBookBohemian',
    meta: {
      cnName: 'bohemian页',
    },
    component: () =>
      import('@/views/theme-page/trendBookSeries/TrendBookBohemian.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/eyewear-moments',
    name: 'TrendBookEyewearMoments',
    meta: {
      cnName: 'eyewear-moments页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookEyewearMoments.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/indie-sleaze',
    name: 'TrendBookSleaze',
    meta: {
      cnName: 'indie-sleaze页',
    },
    component: () =>
      import('@/views/theme-page/trendBookSeries/TrendBookSleaze.vue').then((r) => r.default || r),
  },
  {
    path: '/cult-vision/festival-guide',
    name: 'TrendBookFestivalGudie',
    meta: {
      cnName: 'festival-guide页',
    },
    component: () =>
      import('@/views/theme-page/trendBookSeries/TrendBookFestivalGudie.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/login-ef',
    name: 'MusicFestivalScanPage',
    meta: {
      cnName: '扫码页',
    },
    component: () =>
      import('@/views/theme-page/music-festival/ScanPage.vue').then((r) => r.default || r),
  },
  {
    path: '/cult-vision/edm-festival-style-eyewear',
    name: 'TrendBookFestivalStyleEyewear',
    meta: {
      cnName: '音乐节活动页',
    },
    component: () =>
      import('@/views/theme-page/music-festival/TrendBookFestivalStyleEyewear.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/raver-types',
    name: 'TrendBookRaverTypes',
    meta: {
      cnName: 'raver-types页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookRaverTypes.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/psychedelic-raver',
    name: 'TrendBookPsychedelicRaver',
    meta: {
      cnName: 'psychedelic-raver页',
    },
    component: () =>
      import('@/views/theme-page/trendBookSeries/TrendBookPsychedelicRaver.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/90s-club',
    name: 'TrendBook90sClub',
    meta: {
      cnName: '90s-club页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBook90sClub.vue').then((r) => r.default || r),
  },
  {
    path: '/cult-vision/tiedye',
    name: 'TrendBookTiedye',
    meta: {
      cnName: 'tiedye页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookTiedye.vue').then((r) => r.default || r),
  },
  {
    path: '/festival-quiz',
    name: 'FestivalQuiz',
    meta: {
      cnName: 'festival-quiz页',
    },
    component: () =>
      import('@/views/theme-page/FestivalQuiz/FestivalQuiz.vue').then((r) => r.default || r),
  },
  {
    path: '/eyewear-summer-sale-2025',
    name: 'EvewearSummerSale2025',
    meta: {
      pos: 0,
      cnName: '夏季促销',
    },
    component: () =>
      import('~/views/theme-page/EvewearSummerSale2025/EvewearSummerSale2025.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/festival-eyecare',
    name: 'TrendBookFestivalEyecare',
    meta: {
      cnName: 'festival-eyecare页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookFestivalEyecare.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/leave-no-trace',
    name: 'TrendBookLeaveNoTrace',
    meta: {
      cnName: 'leave-no-trace页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookLeaveNoTrace.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/music-road-trip',
    name: 'TrendBookMusicRoadTrip',
    meta: {
      cnName: 'music-road-trip页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookMusicRoadTrip.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/summer-retro-eyewear',
    name: 'TrendBookSummerRetroEyewear',
    meta: {
      cnName: 'summer-retro-eyewear页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookSummerRetroEyewear.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/cult-vision/festival-photography-guide',
    name: 'TrendBookFestivalPhotographyGuide',
    meta: {
      cnName: 'festival-photography-guide页',
    },
    component: () =>
      import('~/views/theme-page/trendBookSeries/TrendBookFestivalPhotographyGuide.vue').then(
        (r) => r.default || r,
      ),
  },
  // 买赠活动页
  {
    path: '/buy-get/:id',
    name: 'BuyGet',
    meta: {
      cnName: '买赠活动页',
    },
    component: () => import('@/views/theme-page/BuyGet/BuyGet.vue').then((r) => r.default || r),
  },
];
